<template>
  <div>
    <PageAllow
      controller="OrderRulers"
      :action="
        $route.query.mode && $route.query.mode == 'view'
          ? 'quantityView'
          : 'saveQuantity'
      "
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(isNew ? "CRUD.newInfo" : "CRUD.editInfo", [
              ruleType == 2
                ? $t("MaterialOrderRule.numberMatchRule.title")
                : "",
            ])
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $permission.checkAccountExpired().then(() => {
                    $router.replace('/material-order-rules?type=' + ruleType);
                  })
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("MaterialOrderRule.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-row align="center" class="ma-0 bgGreen" style="height: 45px">
          <span class="mx-7 subtitle-2 font-weight-bold">
            {{
              ruleType == 2 ? $t("MaterialOrderRule.numberMatchRule.hint") : ""
            }}
          </span>
        </v-row>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.Fields.rule_name") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.Fields.rule_name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="order_rule.name"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.name }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right mt-1">
                  {{
                    $t("MaterialOrderRule.maxOrderRule.num_type") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row>
                    <v-col>
                      <span v-if="savable">
                        <v-radio-group row v-model="check_type" class="mt-0">
                          <v-radio
                            :label="$t('MaterialOrderRule.maxOrderRule.numTypesDetail.order')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :key="2"
                            :value="2"
                          >
                            <template v-slot:label>
                              <div>{{ $t('MaterialOrderRule.maxOrderRule.numTypesDetail.daily') }}
                                <span class="red--text" style="font-size:0.75rem">{{ $t('MaterialOrderRule.maxOrderRule.numTypesDetail.daily_hint') }}</span>
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span>
                    {{ (check_type == 2) ? $t('MaterialOrderRule.maxOrderRule.numTypesDetail.daily') : $t('MaterialOrderRule.maxOrderRule.numTypesDetail.order') }}
                  </span>
                </v-col>
              </v-row>
              <!-- 数量匹配规则：要货商品A -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.numberMatchRule.materialsA") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                  <br />
                  <v-btn
                    v-if="savable"
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="materialAs_dialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("MaterialOrderRule.Fields.material"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="materialHeaders"
                    :items="materialAItems"
                    :loading="materialAsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.Description="{ item }">
                      <span>{{ item.material_name }}</span>
                      <br />
                      <span class="caption secondary--text">
                        {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                        <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                          {{ item.standard_name.slice(0, 12) + "......" }}
                        </span>
                        <span v-else>
                          {{ item.standard_name }}
                        </span>
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materialAs.splice(
                            materialAs.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 数量匹配规则：要货商品B -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.numberMatchRule.materialsB") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                  <br />
                  <v-btn
                    v-if="savable"
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="materialBs_dialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("MaterialOrderRule.Fields.material"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="materialHeaders"
                    :items="materialBItems"
                    :loading="materialBsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.Description="{ item }">
                      <span>{{ item.material_name }}</span>
                      <br />
                      <span class="caption secondary--text">
                        {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                        <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                          {{ item.standard_name.slice(0, 12) + "......" }}
                        </span>
                        <span v-else>
                          {{ item.standard_name }}
                        </span>
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materialBs.splice(
                            materialBs.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 分组 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.Fields.application_districts") +
                    $t("Global.colon")
                  }}
                  <br />
                  <span v-if="savable">
                    <v-btn
                      color="primary"
                      class="my-1 mr-3"
                      x-small
                      outlined
                      @click="districts_dialog = true"
                    >
                      {{
                        $t("CRUD.chooseInfo", [
                          $t("MaterialOrderRule.Fields.application_districts"),
                        ])
                      }}
                    </v-btn>
                    <br />
                    <span class="text-caption">
                      {{ $t("MaterialOrderRule.Fields.districts_hint") }}
                    </span>
                  </span>

                  <!-- 适用组别 -->
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="districtHeaders"
                    :items="districts"
                    :loading="districtsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          districts.splice(
                            districts.findIndex(
                              (district) => district.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $permission.checkAccountExpired().then(() => {
                      $router.replace('/material-order-rules?type=' + ruleType);
                    })
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{
                    $t("CRUD.backToList", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&
                  $permission.permissionAllow('OrderRulers', 'saveQuantity')
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="toEdit = true"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{
                    $t("CRUD.editInfo", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('OrderRulers', 'saveQuantity')
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{
                    $t("CRUD.saveInfo", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4" v-if="!isNew">
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-row dense align="center">
                  <span class="text-button">{{
                    $t("MaterialOrderRule.Fields.status")
                  }}</span>
                  <v-spacer></v-spacer>
                  <v-chip small label color="gray" text-color="black"
                    >{{ order_rule.status | orderRuleStatusText }}
                  </v-chip>
                </v-row>
              </v-col>
              <!-- <v-col cols="12">
                <v-btn color="primary" class="elevation-1 my-1" block>
                  <span class="mx-2">
                    {{ order_rule.status | orderRuleStatusText }}
                  </span>
                </v-btn>
              </v-col> -->
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('OrderRulers', 'updateStatus')
                "
              >
                <v-btn
                  v-if="order_rule.status"
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="changeStatus()"
                >
                  {{ $t("MaterialOrderRule.Fields.stop_use") }}
                </v-btn>
                <v-btn
                  v-else
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="useRuleDialog = true"
                >
                  {{ $t("MaterialOrderRule.Fields.start_use") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
      <MaterialsSelectsDialog
        v-model="materialAs_dialog"
        @confirm="materialAs = $event"
        :disabledIds="materialBIds"
      />
      <MaterialsSelectsDialog
        v-model="materialBs_dialog"
        @confirm="materialBs = $event"
        :disabledIds="materialAIds"
      />
      <DialogDistricts
        v-model="districts_dialog"
        :districtSelected="districts"
        @confirm="districts = $event"
      />
      <DialogAlert
        v-model="useRuleDialog"
        :message="$t('MaterialOrderRule.Messages.useRule')"
        useConfirm
        persistent
        @confirm="changeStatus(true)"
      />
      <DialogAlert
        v-model="isLeaveDialog"
        :message="alertMessage"
        persistent
        useConfirm
        @confirm="confirmLeave = true"
      />
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import DialogDistricts from "@/components/plugins/DialogDistricts";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import DialogAlert from "@/components/plugins/DialogAlert";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import OrderRules from "@/api/order_rules";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Required,
    MaterialsSelectsDialog,
    DialogDistricts,
    DialogAlert,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.materialOrderRules"),
          disabled: true,
          href: "/material-order-rules",
        },
      ];
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isView() {
      return this.mode == "view";
    },
    ruleType() {
      return this.$route.query.type;
    },

    materialHeaders() {
      var materialHeaders = [];
      materialHeaders.push({
        text: i18n.t("MaterialOrderRule.Fields.category_name"),
        align: "start",
        sortable: false,
        value: "material_category.name",
      });
      materialHeaders.push({
        text: i18n.t("MaterialOrderRule.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      });
      materialHeaders.push({
        text: i18n.t("MaterialOrderRule.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "Description",
      });
      if (this.savable) {
        materialHeaders.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      return materialHeaders;
    },
    districtHeaders() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.district_code"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.district_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },

    materialAItems() {
      return this.materialAs.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },

    materialBItems() {
      return this.materialBs.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    mode: "",
    order_rule: {},
    conditions: {},
    serverErrors: [],
    materialAs_dialog: false,
    materialAs: [],
    materialAIds: [],
    materialAsLoading: false,
    materialBs_dialog: false,
    materialBs: [],
    materialBIds: [],
    materialBsLoading: false,
    districts_dialog: false,
    districts: [],
    districtsLoading: false,
    useRuleDialog: false,
    submit_data: {},
    isLeave: false,
    isLeaveDialog: false,
    alertMessage: "",
    confirmLeave: false,
    toPage: "",
    toEdit: false,
    check_type: 1,
  }),

  mounted() {
    if (this.$route.params.id == 0) {
      this.mode = "new";
    } else {
      this.mode = this.$route.query.mode ? this.$route.query.mode : "view";
      this.getOrderRuleFromAPI(this.$route.params.id);
    }
  },

  methods: {
    getOrderRuleFromAPI(id) {
      OrderRules.fetchOne(id, { type: this.ruleType }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order_rule = response.data.order_ruler;
            this.conditions = response.data.order_ruler.conditions;
            if (response.data.order_ruler.conditions.materialAs) {
              this.materialAs = response.data.order_ruler.conditions.materialAs;
            }
            if (response.data.order_ruler.conditions.materialBs) {
              this.materialBs = response.data.order_ruler.conditions.materialBs;
            }

            this.check_type = response.data.order_ruler.conditions.check_type
              ? response.data.order_ruler.conditions.check_type
              : 1;

            this.districts =
              response.data.order_ruler.districts &&
              response.data.order_ruler.districts.length
                ? response.data.order_ruler.districts
                : [];
          }
        }.bind(this)
      );
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            if (
              this.ruleType == 2 &&
              (!this.materialAs.length || !this.materialBs.length)
            ) {
              this.$store.dispatch("fullscreenLoadingStop");
              this.$snackbar.error(
                i18n.t("MaterialOrderRule.Messages.materialsAOrBNull")
              );
            } else {
              //整理适用的分组和商品
              let district_ids = [];
              if (this.districts.length) {
                district_ids = this.districts.map((district) => {
                  return district.id;
                });
              }

              let materialA_ids = [];
              if (this.materialAs.length) {
                materialA_ids = this.materialAs.map((material) => {
                  return material.id;
                });
              }
              let materialB_ids = [];
              if (this.materialBs.length) {
                materialB_ids = this.materialBs.map((material) => {
                  return material.id;
                });
              }

              //整理提交数据

              this.submit_data = Object.assign({}, this.submit_data, {
                district_ids: district_ids,
                materialA_ids: materialA_ids,
                materialB_ids: materialB_ids,
                check_type: this.check_type,
              });

              //判断是新建还是编辑
              if (this.mode == "edit" || this.order_rule.id) {
                this.submit_data = Object.assign({}, this.submit_data, {
                  id: this.order_rule.id
                    ? this.order_rule.id
                    : this.$route.params.id,
                });
              }

              //接口提交保存
              OrderRules.save(
                this.ruleType,
                Object.assign({}, this.submit_data, {
                  name: this.order_rule.name,
                })
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.order_rule = response.data.order_ruler;
                      this.$snackbar.success(
                        i18n.t("MaterialOrderRule.Messages.saveSuccess")
                      );
                      if (!this.order_rule.status) {
                        this.useRuleDialog = true;
                      }
                      if (this.isNew) {
                        this.mode = "edit";
                      }
                    } else if (
                      response.data.error &&
                      response.data.error.data &&
                      "ERR333" == response.data.error.code
                    ) {
                      this.serverErrors = response.data.error.data;
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    changeStatus(backToList) {
      OrderRules.changeStatus(this.order_rule.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (backToList) {
              this.confirmLeave = true;
              this.$router.replace(
                "/material-order-rules?type=" + this.ruleType
              );
            } else {
              this.getOrderRuleFromAPI(this.order_rule.id);
            }
          }
        }.bind(this)
      );
    },
  },

  watch: {
    confirmLeave: {
      deep: true,
      handler() {
        if (this.confirmLeave) {
          if (this.toPage.path.startsWith("/material-order-rules")) {
            this.$router.replace("/material-order-rules?type=" + this.ruleType);
          } else {
            this.$router.replace(this.toPage.path);
          }
        }
      },
    },
    toEdit: {
      handler() {
        if (this.toEdit) {
          this.$router.replace({
            path: this.$route.path,
            query: { type: this.order_rule.type, mode: "edit" },
          });
          this.mode = "edit";
        }
      },
    },
    materialBs: {
      handler() {
        if (this.materialBs.length) {
          this.materialBIds = this.materialBs.map((material) => {
            return material.id;
          });
        } else {
          this.materialBIds = [];
        }
      },
    },
    materialAs: {
      handler() {
        if (this.materialAs.length) {
          this.materialAIds = this.materialAs.map((material) => {
            return material.id;
          });
        } else {
          this.materialAIds = [];
        }
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (!this.order_rule.status && !this.isNew) {
      this.toPage = to;
      if (this.confirmLeave) {
        next();
      } else if (!this.toEdit) {
        this.isLeaveDialog = true;
        this.alertMessage = i18n.t(
          "MaterialOrderRule.Messages.isLeaveALertMsg"
        );
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
</script>